<ng-container>
    <span id="htmlContainer" #htmlContainer>
        @if (form) {
            <div class="w-full float-left">
                <div class="grid grid-cols-4 gap-6 w-full h-full">
                    <div class="col-span-4 lg:col-span-2 relative">
                        @if (form?.get('gengi')?.value != '') {
                            <button id="c-downloadButton" (click)="printOrSave()" mat-flat-button type="submit" [color]="'bg-gray-100'">
                                @if (formEnabled) {
                                    <span> Prenta / Vista </span>
                                }
                            </button>
                        }
                        <span class="p-8 float-left w-100">
                            <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
                                <h2>Skrá gengi</h2>
                                <p>
                                    Hér skráir þú gengi fyrir séreignarsjóði LSR. Gengið skráist í réttindakerfið Kríu fyrir valda
                                    dagsetningu og sjóð.
                                </p>
                            </div>
                            <span class="separator-line block mb-[30px]"></span>
                            <form [formGroup]="form" #profileInNgForm="ngForm" (keyup.enter)="save()">
                                <div class="grid sm:grid-cols-4 gap-6 w-full">
                                    <ng-container>
                                        <div class="col-span-4 sm:col-span-2">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>Séreignarleið (sjóður)</mat-label>
                                                <mat-select
                                                    (selectionChange)="onChangeLeid($event.value)"
                                                    formControlName="sereignarleid"
                                                    placeholder="Séreignarleið"
                                                >
                                                    @for (leid of sereignarleidir; track leid) {
                                                        <mat-option [value]="leid.value">
                                                            {{ leid.viewValue }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-4 sm:col-span-2">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>Dagsetning</mat-label>
                                                <input
                                                    class="date"
                                                    (dateChange)="onChangeDate($event.value)"
                                                    formControlName="dagsetning"
                                                    matInput
                                                    placeholder="Dagsetning"
                                                    (click)="dagsetning.open()"
                                                    [matDatepicker]="dagsetning"
                                                />
                                                <mat-datepicker-toggle matSuffix [for]="dagsetning"></mat-datepicker-toggle>
                                                <mat-datepicker #dagsetning></mat-datepicker>
                                                @if (this.form?.get('dagsetning')?.hasError('required')) {
                                                    <mat-error>
                                                        Það
                                                        <strong>þarf</strong> að velja dagsetningu
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        @if (!skraGengiSimple) {
                                            <div class="col-span-4">
                                                <span class="separator-line block"></span>
                                            </div>
                                            @if (!isAssetsSectionHidden()) {
                                                @if (additionalValuesRegisteredRateRes && !showComparison) {
                                                    <p class="font-medium text-secondary col-span-4">
                                                        Upplýsingar miðast við þau gildi sem voru skráð við gengisskráningu á valinni
                                                        dagsetningu
                                                    </p>
                                                } @else {
                                                    <p class="font-medium text-secondary col-span-4">
                                                        Upplýsingar miðast við nýjustu skráðu upplýsingar fyrir valda dagsetningu
                                                    </p>
                                                }
                                            }
                                            <div class="col-span-4 sm:col-span-2">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Markaðsverð eigna</mat-label>
                                                    <input id="markadsverd" [formControlName]="'markadsverd'" matInput />
                                                    <span matSuffix>ISK</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-span-4 sm:col-span-2">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Útistandandi einingar</mat-label>
                                                    <input id="utistandandiEiningar" [formControlName]="'utistandandiEiningar'" matInput />
                                                </mat-form-field>
                                            </div>
                                            <div class="col-span-4 sm:col-span-2">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Hreyfingar úr réttindakerfi</mat-label>
                                                    <input
                                                        id="vidskiptiGaerdagsins"
                                                        numericFormat
                                                        (keyup)="calculateGengi()"
                                                        [formControlName]="'vidskiptiGaerdagsins'"
                                                        matInput
                                                    />
                                                    <span matSuffix>ISK</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-span-4 sm:col-span-2">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Viðbót við markaðsverð</mat-label>
                                                    <input
                                                        id="vidbotVidMarkadsverd"
                                                        numericFormat
                                                        (keyup)="calculateGengi()"
                                                        [formControlName]="'vidbotVidMarkadsverd'"
                                                        matInput
                                                    />
                                                    <span matSuffix>ISK</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-span-4 sm:col-span-2">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Óuppgerð verðbréfaviðskipti</mat-label>
                                                    <input
                                                        id="ouppgerdVerdbrefavidskipti"
                                                        numericFormat
                                                        (keyup)="calculateGengi()"
                                                        [formControlName]="'ouppgerdVerdbrefavidskipti'"
                                                        matInput
                                                    />
                                                    <span matSuffix>ISK</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-span-4 sm:col-span-4">
                                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                                    <mat-label>Viðbótarupplýsingar</mat-label>
                                                    <textarea
                                                        class="text-area"
                                                        maxlength="250"
                                                        matInput
                                                        formControlName="comments"
                                                    ></textarea>
                                                </mat-form-field>
                                            </div>
                                        }
                                    </ng-container>
                                </div>
                                @if (skraGengiEnabled) {
                                    <span class="fade-in-left flex mt-6 items-center justify-start w-100 float-left w-full">
                                        <div class="col-span-4 sm:col-span-2">
                                            <mat-form-field class="w-full">
                                                <mat-label>Gengi</mat-label>
                                                <input id="gengi" [formControlName]="'gengi'" matInput />
                                                @if (!skraGengiSimple) {
                                                    <button
                                                        mat-icon-button
                                                        matSuffix
                                                        matTooltip="Afrita gildi"
                                                        (click)="copyLink(form.get('gengi')?.value)"
                                                    >
                                                        <mat-icon class="icon-size-5" svgIcon="mat_solid:content_copy"></mat-icon>
                                                    </button>
                                                }
                                            </mat-form-field>
                                        </div>
                                    </span>
                                }
                                @if (showComparison || !additionalValuesRegisteredRateRes) {
                                    <div class="fade-in-left flex items-center justify-end mt-[20px] w-full">
                                        @if (form.dirty) {
                                            <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                                                {{ 'label_cancel' | translate }}
                                            </button>
                                        }
                                        <button
                                            class="ml-4"
                                            (click)="save()"
                                            mat-flat-button
                                            type="submit"
                                            [color]="'primary'"
                                            [disabled]="!formEnabled"
                                        >
                                            @if (formEnabled) {
                                                <span>
                                                    {{
                                                        thegarHefurVeridSkradGengi
                                                            ? 'Uppfæra gengi'
                                                            : 'Skrá
                                        gengi'
                                                    }}
                                                </span>
                                            }
                                            @if (!formEnabled) {
                                                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                                            }
                                        </button>
                                    </div>
                                }
                                <span class="mt-1 block float-right w-100 text-right">
                                    @if (thegarHefurVeridSkradGengi) {
                                        <span class="fade-in-left text-sm mt-1 tracking-wider text-secondary block"
                                            >Gengi
                                            <span class="font-semibold">{{ gengiDagsinsSkrad | translocoDecimal }}</span>
                                            hefur þegar verið skráð fyrir valda dagsetningu</span
                                        >
                                    }
                                    @if (thegarHefurVeridSkradGengi) {
                                        <span class="separator-line block mb-[5px] mt-[5px]"></span>
                                    }
                                    @if (sidastaSkradaGengi) {
                                        <span class="fade-in-left text-sm tracking-wider text-secondary block"
                                            >Síðasta gengi skráð þann {{ formatDate(sidastaSkradaGengi.dagsetning) }}:
                                            <span class="font-semibold">{{ sidastaSkradaGengi.gengi | translocoDecimal }}</span></span
                                        >
                                    }
                                    @if (mismunurFraSidustuSkraningu) {
                                        <span class="fade-in-left text-sm tracking-wider text-secondary block"
                                            >Mismunur á gengi frá síðustu skráningu:
                                            <span
                                                class="font-semibold"
                                                [ngClass]="{
                                                    'alert-safe-bg': checkTotalGengiAlert(mismunurFraSidustuSkraningu),
                                                }"
                                                >{{ toFixed((1 - mismunurFraSidustuSkraningu) * -100, 4) | translocoDecimal }} %</span
                                            ></span
                                        >
                                    }
                                </span>

                                <!-- Óuppgerð Verðbréfaviðskipti Upplysingar -->
                                @if (showApxTransactionsAssets) {
                                    <div class="prose prose-sm !max-w-100 col-span-4 mt-[150px] mb-[20px]">
                                        <h3>Hreyfingalisti - Óuppgerð verðbréfaviðskipti</h3>
                                    </div>

                                    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
                                        <table mat-table [dataSource]="apxTransactionsAssetsTableSource" class="w-full">
                                            <ng-container matColumnDef="Meðtalið í útreikningi">
                                                <th mat-header-cell *matHeaderCellDef>Meðtalið í útreikningi</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    <mat-checkbox formControlName="isIncludedTotal"></mat-checkbox>
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <p class="font-bold">Samtals</p>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="symbolAPX">
                                                <th mat-header-cell *matHeaderCellDef>Eign</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('symbolAPX').value }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>
                                            <ng-container matColumnDef="transactionCode">
                                                <th mat-header-cell *matHeaderCellDef>Tegund hreyfingar</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('transactionCode').value }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>
                                            <ng-container matColumnDef="tradeDate">
                                                <th mat-header-cell *matHeaderCellDef>Viðskipti dags</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ formatDate(element.get('tradeDate').value) }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>
                                            <ng-container matColumnDef="settleDate">
                                                <th mat-header-cell *matHeaderCellDef>Uppgjörs dags</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ formatDate(element.get('settleDate').value) }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>
                                            <ng-container matColumnDef="postDate">
                                                <th mat-header-cell *matHeaderCellDef>Skráning dags</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ formatDate(element.get('postDate').value) }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef></td>
                                            </ng-container>
                                            <ng-container matColumnDef="tradeAmount">
                                                <th mat-header-cell *matHeaderCellDef>Upphæð</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('tradeAmount').value | translocoDecimal }}
                                                </td>
                                                <td mat-footer-cell *matFooterCellDef>
                                                    <p class="font-bold">{{ totalAmount | translocoDecimal }}</p>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="apxTransactionsAssetsColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: apxTransactionsAssetsColumns"></tr>
                                            <tr mat-footer-row *matFooterRowDef="apxTransactionsAssetsColumns"></tr>
                                        </table>
                                    </div>
                                }

                                <!-- Assets Index Values Details -->
                                @if (form.get('assetsIndexValuesDetails')?.value.length > 0) {
                                    <div class="prose prose-sm !max-w-100 col-span-4 mt-[100px] mb-[20px]">
                                        <h3>Vísitala</h3>
                                    </div>

                                    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
                                        <table mat-table [dataSource]="assetsIndexValuesTableSource" class="w-full">
                                            <ng-container matColumnDef="seriesIdentifier">
                                                <th mat-header-cell *matHeaderCellDef>Vísitala</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('seriesIdentifier').value }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="dateTodayValue">
                                                <th mat-header-cell *matHeaderCellDef>Gildi í gær</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('dateTodayValue').value }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="dateBeforeValue">
                                                <th mat-header-cell *matHeaderCellDef>Gildi viðmiðunardags</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{ element.get('dateBeforeValue').value }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="difference">
                                                <th mat-header-cell *matHeaderCellDef>Breyting milli daga(%)</th>
                                                <td mat-cell *matCellDef="let element" [formGroup]="element">
                                                    {{
                                                        element.difference == 0
                                                            ? 0
                                                            : (toFixed(100 - element.get('difference').value * 100, 4) * -1
                                                              | translocoDecimal)
                                                    }}
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="assetsIndexValuesColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: assetsIndexValuesColumns"></tr>
                                        </table>
                                    </div>
                                }
                            </form>
                        </span>
                    </div>
                    <!-- Assets section -->
                    <div
                        [ngClass]="{
                            hidden: isAssetsSectionHidden() || skraGengiSimple,
                        }"
                        id="tableContainerParent"
                        class="fade-in-left col-span-4 lg:col-span-2 border-l ml-2"
                    >
                        <div id="tableContainer" class="w-full sm:w-auto float-left w-full bg-basic-gray overflow-x-auto">
                            <div
                                id="header"
                                class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 pb-4 md:px-8 border-b"
                            >
                                <div
                                    class="absolute top-1 right-2 mt-2 font-medium text-secondary float-right text-right"
                                    *ngIf="form.get('dagsetning')?.value"
                                >
                                    Viðmiðunardagsetning:
                                    {{ getCalendarTwoDaysBeforeOrThursday(form.get('dagsetning')?.value) | date: 'dd.MM.yyyy' }}
                                    <br />
                                    Markaðsdagsetning:
                                    {{ getCalendarPreviousDayOrFriday(form.get('dagsetning')?.value) | date: 'dd.MM.yyyy' }}
                                </div>
                                <!-- Title -->
                                <div>
                                    <div class="prose prose-sm col-span-4 mt-8">
                                        <h2 class="mb-0">
                                            {{ form?.get('sereignarleid')?.value }}
                                            - Eignir í eignasafni
                                        </h2>
                                    </div>
                                    <div class="ml-0.5 font-medium text-secondary">
                                        @if (displayedData.filteredData.length > 0) {
                                            {{ displayedData.filteredData.length }}
                                        }
                                        {{
                                            displayedData.filteredData.length
                                                | i18nPlural
                                                    : {
                                                          '=0': 'Engar eignir fundust',
                                                          '=1': 'eign',
                                                          other: 'eignir',
                                                      }
                                        }}
                                    </div>
                                </div>
                                <!-- Main actions -->
                                <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                                    <!-- Search -->
                                    <div class="flex-auto">
                                        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"> </mat-icon>
                                            <input matInput placeholder="Leita" (keyup)="searchFilter($event.target.value)" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <!-- Select to view data comparison -->
                                <span class="mt-4 sm:mt-0 md:mt-4">
                                    <mat-checkbox [checked]="showComparison" (change)="onShowComparisonNewOldDataChange($event.checked)">
                                        <span class="font-medium text-secondary">Sýna nýjar breytingar í eignasafni</span>
                                    </mat-checkbox>
                                </span>
                            </div>
                            <ng-container *ngTemplateOutlet="marketValueOverviewTable"></ng-container>
                        </div>

                        <!-- Table details -->
                        <ng-template #marketValueOverviewTable>
                            <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData">
                                <ng-container matColumnDef="changeType">
                                    <th mat-sort-header="changeType" mat-header-cell *matHeaderCellDef>Breyting</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.changeType }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="symbol">
                                    <th mat-sort-header="symbol" mat-header-cell *matHeaderCellDef>Eign</th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{ element.symbol }} -
                                        {{ element.symbolName }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="marketValueToday">
                                    <th mat-sort-header="marketValueToday" mat-header-cell *matHeaderCellDef>Markaðsverð dagsins (ISK)</th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{ element.marketValueToday | translocoDecimal }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="marketValueBefore">
                                    <th mat-sort-header="marketValueBefore" mat-header-cell *matHeaderCellDef>
                                        Markaðsverð viðmiðunardags (ISK)
                                    </th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{ element.marketValueBefore | translocoDecimal }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="closingPriceToday">
                                    <th mat-sort-header="closingPriceToday" mat-header-cell *matHeaderCellDef>Gengi í gær</th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{ element.closingPriceToday | translocoDecimal }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="closingPriceBefore">
                                    <th mat-sort-header="closingPriceBefore" mat-header-cell *matHeaderCellDef>Gengi viðmiðunardags</th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{ element.closingPriceBefore | translocoDecimal }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="closingPriceDifference">
                                    <th
                                        [matTooltip]="'Breyting milli daga'"
                                        mat-sort-header="closingPriceDifference"
                                        mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        Br.m.d. (%)
                                    </th>
                                    <td
                                        mat-cell
                                        [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }"
                                        *matCellDef="let element"
                                    >
                                        {{
                                            element.closingPriceDifference == 0
                                                ? 0
                                                : (toFixed(100 - element.closingPriceDifference * 100, 4) * -1 | translocoDecimal)
                                        }}
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: headerColumns"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    @if (loaded) {
                                        <div class="flex items-center justify-between">
                                            <span>
                                                <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">Engir sjóðir fundust</div>
                                            </span>
                                        </div>
                                    }
                                </tr>
                            </table>
                            <mat-paginator
                                #tablePaginator
                                class="justify-end table-paginator"
                                showFirstLastButtons
                                [pageSize]="50"
                                [pageSizeOptions]="[10, 25, 50, 100]"
                            >
                            </mat-paginator>
                        </ng-template>
                    </div>
                </div>
            </div>
        }
    </span>
</ng-container>
